import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IFidc } from '../interface/IFidc';

enum FidcServiceServiceEnum {
  base = "/",
  fidcList = "/"
}

export default class FidcService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/fidc");
  }

  public getAll = async (): Promise<IFidc[]> => await this.GET(FidcServiceServiceEnum.base);
  public create = async (data: IFidc): Promise<IFidc> => await this.POST(FidcServiceServiceEnum.base, data);
  public update = async (data: IFidc): Promise<IFidc> => await this.PUT(FidcServiceServiceEnum.base, data);
  public getById = async (id: number): Promise<IFidc> => await this.GET(FidcServiceServiceEnum.base + id);
}
